import { Button } from '@abyss/web/ui/Button';
import React from 'react';

interface SignInProps {
  url: string;
  text: string;
  locale?: string;
}

export const SignIn: React.FC<SignInProps> = ({ text, url, locale }) => {
  const currentUrl = window.location.href;
  const isFindcareLoaded = currentUrl.includes('/browse');

  return (
    <Button
      data-auto-testid="guest-header-sign-in-button"
      data-testid="guest-header-sign-in-button"
      href={
        !isFindcareLoaded
          ? url + (locale ? `?locale=${locale}` : '?locale=en-US')
          : url
      }
      size="$md"
      variant="outline"
    >
      {text}
    </Button>
  );
};
